import React from "react";

export default function Home() {
  return (
    <div className="min-h-screen bg-gray-950 text-white p-6">
      <h1 className="text-3xl font-bold mb-4">🏠 IAdeportiva</h1>
      <p className="text-gray-400 mb-6">
        Aquí verás todos los partidos disponibles de todas las ligas y próximamente noticias generadas por IA.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {[...Array(6)].map((_, index) => (
          <div
            key={index}
            className="bg-gray-800 rounded-xl p-4 shadow hover:scale-[1.02] transition-transform"
          >
            <h3 className="text-lg font-bold mb-2">Partido #{index + 1}</h3>
            <p className="text-sm text-gray-400">Ejemplo de vista general combinando todas las ligas.</p>
          </div>
        ))}
      </div>
    </div>
  );
}
